// @flow
import { memo, useCallback } from 'react';
import * as csx from 'csstips';
import classify from '@src/utils/typestyle';

import type { DiamondType } from '@types/diamond';
import { trackAddToCart } from "../../utils/googleAnalytics";

const classes = classify({
  buttonContainer: {
    position: 'relative',
    display: 'inline-block'
  },
  button: {
    ...csx.horizontal,
    ...csx.centerJustified,
    ...csx.center,
    height: '40px',
    padding: '0 20px',
    fontSize: '14px',
    lineHeight: '22px',
    fontFamily: '"acumin-pro", Arial, Helvetica, sans-serif',
    fontDisplay: 'swap',
    fontWeight: 600,
    width: '100%',
    '&:hover': {
      color: 'white'
    }
  },
  form: {
    width: '100%'
  }
});

type PropsType = {
  diamond: DiamondType
};

const ChooseLooseDiamondButton = memo(({ diamond }: PropsType) => {
  const handleSubmitForm = useCallback(
    e => {
      e.preventDefault();

      trackAddToCart(diamond);

      e.currentTarget.submit();
    }, [diamond]);

  return (
    <div className={classes.buttonContainer}>
      <form
        action={`/orders/add_to_cart`}
        method='POST'
        className={classes.form}
        onSubmit={handleSubmitForm}
      >
        <input
          type='hidden'
          name='authenticity_token'
          value={
            typeof document !== 'undefined' && ReactOnRails.authenticityToken()
          }
        />
        <input type='hidden' name='id' value={diamond.list_service_diamond_id} />
        <input type='hidden' name='item_type' value='diamond' />
        <button type='submit' className={classes.button}>
          Choose This Diamond
        </button>
      </form>
    </div>
  );
});

export default ChooseLooseDiamondButton;
